import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import './TextArea.scss';

const TextArea = ({
  ariaRequired,
  className,
  name,
  onChange,
  placeholder,
  value,
  disabled,
  errors,
  reference,
  dangerouslySetInnerHTML,
}) => {
  const [inputValue, setInputValue] = useState(value);

  useEffect(() => {
    onChange({ [name]: inputValue });
  }, []);

  useEffect(() => {
    // If parent value changes, sync local state and notify parent
    if (value !== inputValue) {
      setInputValue(value);
      onChange({ [name]: value });
    }
  }, [value]);

  const handleChange = (e) => {
    const newValue = e.target.value;
    setInputValue(newValue);
    onChange({ [name]: newValue });
  };

  const invalid = errors.indexOf(name) !== -1;
  // eslint-disable-next-line no-underscore-dangle
  const translation = dangerouslySetInnerHTML?.__html || placeholder;

  return (
    <textarea
      aria-required={ariaRequired}
      className={cx('TextArea', className, {
        'TextArea--error': invalid,
      })}
      id={name}
      name={name}
      onChange={handleChange}
      placeholder={translation}
      value={inputValue || ''}
      disabled={disabled}
      ref={reference}
    />
  );
};

TextArea.propTypes = {
  ariaRequired: PropTypes.bool,
  className: PropTypes.string,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  value: PropTypes.string,
  disabled: PropTypes.bool,
  errors: PropTypes.arrayOf(PropTypes.string),
  reference: PropTypes.func,
  dangerouslySetInnerHTML: PropTypes.shape({
    __html: PropTypes.string,
  }),
};

TextArea.defaultProps = {
  ariaRequired: false,
  className: null,
  placeholder: null,
  value: '',
  disabled: false,
  errors: [],
  reference: undefined,
  dangerouslySetInnerHTML: {
    __html: '',
  },
};

TextArea.displayName = 'TextArea';
export default TextArea;
